export const OTHERS = [
  {
    metaTitle: 'OUTLET Products',
    targetPath: '/campaign/outlet.html',
    keywords: 'eyeglasses,eyewear,sunglasses,lens,outlet,sale,campagin,Singapore,OWNDAYS',
    ogImage: null,
    description: `OUTLET limited stock, Save up 50% on trendy eyewear! Big Deals on Big Style ! Shop from our Outlet section Now !`,
    canonicalUrl: 'https://www.owndays.com/sg/en/campaign/outlet.html',
  },
  {
    metaTitle: 'Collections | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/brands',
    keywords:
      'Collections,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses,Singapore',
    ogImage: null,
    description: `Browse the extensive collection of eyewear at OWNDAYS. Each collection is built upon a unique design concept that is catered a specific audience in mind. Be it fashion-forward, basic or functional, we’re sure you’ll find eyewear that complements your personality and style!`,
    canonicalUrl: 'https://www.owndays.com/sg/en/brands',
  },
  {
    metaTitle: 'FAQ | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/faq',
    keywords: 'FAQ, contact, help, OWNDAYS, stores, warranty, services',
    ogImage: null,
    description: `Need help? Refer to our frequently asked questions on our products, stores, warranty and services.`,
    canonicalUrl: 'https://www.owndays.com/sg/en/faq',
  },
  {
    metaTitle: `It's a great way to send a gift to your loved ones!`,
    targetPath: '/gift-ticket',
    keywords: '',
    ogImage: 'https://static.lenskart.com/media/owndays/img/gift-ticket/og-gift-ticket.webp',
    description: `A digital gift card that can be used at both the physical stores and the online store.`,
    canonicalUrl: 'https://www.owndays.com/sg/en/gift-ticket',
  },
  {
    metaTitle: 'OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/account/login',
    keywords:
      'membership,Membership,Online Store,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses,Singapore',
    ogImage: null,
    description: `Join the OWNDAYS membership and earn points on all purchases. Enjoy exclusive perks and hassle-free shopping with no membership fee.`,
    canonicalUrl: 'https://www.owndays.com/sg/en/customer/account/login',
  },
  {
    metaTitle: 'OWNDAYS Membership Programme | Exclusive Benefits & Offers',
    targetPath: '/account',
    keywords:
      'membership,Membership,Online Store,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses,Singapore',
    ogImage: null,
    description: `Join the OWNDAYS membership and earn points on all purchases. Enjoy exclusive perks and hassle-free shopping with no membership fee.`,
    canonicalUrl: 'https://www.owndays.com/sg/en/account',
  },
  {
    metaTitle: 'Eye Camp｜OWNDAYS Singapore Online Store',
    targetPath: '/company/eyecamp',
    keywords:
      'CSR,EYE CAMP,Giving back to society,Regional activity,glasses,spectacles,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses',
    ogImage: 'https://static.lenskart.com/media/owndays/img/eye-camp/ogp_1200x630.webp',
    description: `Join our Eye Camp at OWNDAYS Singapore Online Store. Get your eyes checked by our experts and find the perfect eyewear. Don't miss this opportunity for clearer vision!`,
    canonicalUrl: 'https://www.owndays.com/sg/en/company/eyecamp',
  },
  {
    metaTitle: 'eGift',
    targetPath: '/gift-cards',
    keywords: 'eGift,eyeglasses,sunglasses,lens,gift,present,digitalgift,Singapore,OWNDAYS',
    ogImage: null,
    description: `What better way to show your loved ones that you care than the gift of sight? From birthdays to holidays, our OWNDAYS eGift is the perfect present for any occasion. Take your pick from our curated designs and add a personal message for an extra human touch.`,
    canonicalUrl: 'https://www.owndays.com/sg/en/gift-cards',
  },
  {
    metaTitle: 'Privacy Policy | OWNDAYS Singapore',
    targetPath: '/privacy',
    keywords:
      'Privacy Policy,OWNDAYS,Singapore,eyeglasses,sunglasses,lens,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses',
    ogImage: null,
    description: `Explore OWNDAYS Privacy Policy. Your data’s security is our priority. Understand how we handle your personal information. Act now, stay informed and secure!`,
    canonicalUrl: 'https://www.owndays.com/sg/en/privacy',
  },
  {
    metaTitle: 'Cart｜OWNDAYS',
    targetPath: '/cart',
    keywords:
      'cart,OWNDAYS,Singapore,eyeglasses,sunglasses,lens,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses',
    ogImage: null,
    description: 'Cart｜OWNDAYS',
    canonicalUrl: 'https://www.owndays.com/sg/en/cart',
  },
  {
    metaTitle: 'Terms & Conditions | OWNDAYS Singapore',
    targetPath: '/terms',
    keywords:
      'Terms & Conditions,OWNDAYS,Singapore,eyeglasses,sunglasses,lens,optical shop,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses',
    ogImage: null,
    description:
      'Discover OWNDAYS Singapore and understand our terms & conditions for a smooth shopping journey. Ensuring transparency and trust in your eyewear purchases.',
    canonicalUrl: 'https://www.owndays.com/sg/en/terms',
  },
  {
    metaTitle: 'Gundam × OWNDAYS | Collaboration Frames | OWNDAYS Singapore',
    targetPath: '/collabo/gundam/pj-snap',
    keywords:
      'Collaboration Frames,GUNDAM,40th Anniversary,Collaboration,spectacles,glasses,eye glasses,sunglasses,OWNDAYS,SNAP',
    ogImage: 'https://static.lenskart.com/owndays/img/collabo/pj-snap/ogp_1200x630.jpg',
    description: `Step into the world of GUNDAM with our exclusive eyewear collection. These iconic frames blend style and fandom seamlessly. Own a piece of the GUNDAM universe – shop now!`,
    canonicalUrl: 'https://www.owndays.com/sg/en/collabo/gundam/pj-snap',
  },
  {
    metaTitle: 'Mobile Suit Gundam 40th Anniversary Gundam Head Case | OWNDAYS Singapore',
    targetPath: '/collabo/gundam/pj-head',
    keywords:
      'HEAD CASE,GUNDAM,40th Anniversary,Collaboration,spectacles,glasses,eye glasses,sunglasses,OWNDAYS',
    ogImage: 'https://static.lenskart.com/owndays/img/collabo/pj-head/ogp_1200x630.jpg',
    description: `OWNDAYS collaborates with iconic anime, Mobile Suit Gundam, elevating eyewear with unmatched details exclusive to this range. More than just spectacle storage.`,
    canonicalUrl: 'https://www.owndays.com/sg/en/collabo/gundam/pj-head',
  },
  {
    metaTitle: 'System Requirement for Virtural Try On | OWNDAYS Singapore',
    targetPath: '/requirement',
    keywords:
      'System Requirements,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses',
    ogImage: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    description:
      'Ensure your device meets OWNDAYS’ Virtual Try-On requirements for a seamless experience. Enable JavaScript and use updated browsers. Secure, easy, and reliable!',
    canonicalUrl: 'https://www.owndays.com/sg/en/requirement',
  },
  {
    metaTitle: 'Site Map | OWNDAYS Singapore Online Store',
    targetPath: '/sitemap',
    keywords:
      'Site Map,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses',
    ogImage: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    description:
      'Navigate effortlessly through OWNDAYS with our comprehensive site map. Discover eyewear, offers, and more. Your perfect pair is a click away. Explore now!',
    canonicalUrl: 'https://www.owndays.com/sg/en/sitemap',
  },
  {
    metaTitle: 'Membership Terms & Conditions | OWNDAYS Singapore',
    targetPath: '/membership-terms',
    keywords:
      'Membership Terms & Conditions,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses',
    ogImage: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    description:
      'Review the Terms and Conditions of the OWNDAYS Membership Programme. Understand the benefits and guidelines of our membership for a better eyewear experience.',
    canonicalUrl: 'https://www.owndays.com/sg/en/membership-terms',
  },
  {
    metaTitle: 'Contact Us | OWNDAYS Singapore Online Store',
    targetPath: '/contact',
    keywords:
      'Contact Us,glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses',
    ogImage: null,
    description: `Contact OWNDAYS Singapore Online Store for any inquiries or assistance. Our team is here to help you with all your eyewear needs. Reach out to us today!`,
    canonicalUrl: 'https://www.owndays.com/sg/en/contact',
  },
  {
    metaTitle: 'Wishlist｜OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/shortlist',
    keywords:
      'glasses,spectacles,optical shop,online store,eyeglasses,OWNDAYS,frame,sunglasses,pc lenses,wishlist',
    ogImage: null,
    description: `Wishlist｜OWNDAYS ONLINE STORE - OPTICAL SHOP`,
    canonicalUrl: 'https://www.owndays.com/sg/en/shortlist',
  },
];
